<template>
    <div class="bi-content">
        <div class="bi-content-top">
            <div class="opera-tit-btn">
                <div class="btn"><el-button type="primary" @click="saveData">保存配置</el-button></div>
            </div>
            <div class="form-data">
                <el-form class="float:left" size="mini" label-width="100px">
                    <el-row>
                        <el-col :span="4">
                          <el-form-item label="数据来源">
                                <el-radio v-model="BIDimension" :label="0" @change="initFormList" :disabled="canChoose">表单</el-radio>
                                <el-radio v-model="BIDimension" :label="2" @change="initFormList" :disabled="canChoose">报表</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="数据模型">
                                 <TreeSelect
                                     placeholder="请选择模型"
                                     ref="treeSelect"
                                     :multiple="false"
                                     :disableBranchNodes="true"
                                     :sourceOptions="appModelsOptions"
                                     @treeSelectChoose="treeSelectChoose"
                                 />
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                          <el-form-item label="维度">
                               <el-select v-model="selectXdata" :disabled="isCanSelect" clearable placeholder="请选择X轴数据字段" @change="changeXdata"  style="width: 100%;">
                                   <el-option
                                       v-for="(item, index) in XData"
                                       :key="index"
                                       :label="BIDimension === 2 ? '【' + item.formName + '】' + item.name : item.name"
                                       :value="item.id"
                                   ></el-option>
                               </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="指标">
                              <el-select
                                  v-model="selectYdata"
                                  :disabled="isCanSelect"
                                  value-key="id"
                                  clearable
                                  placeholder="请选择Y轴数据字段"
                                  @change="changeYdata"
                                  :multiple="yIsmultiple"
                                  style="width: 100%;"
                              >
                                  <el-option
                                      v-for="item in YData"
                                      :key="item.id"
                                      :label="BIDimension === 2 ? '【' + item.formName + '】' + item.name : item.name"
                                      :value="item.id"
                                  ></el-option>
                              </el-select>
                          </el-form-item>
                        </el-col>
                     </el-row>
                     <el-row v-if="allChooseYdata.length>0">
                        <div class="zb-item" v-for="(item,index) in allChooseYdata" :key="index">
                            <div class="item-field"><span class="field-name-border">【</span>
                                <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                  <span class="field-name">{{item.name}}</span>
                                </el-tooltip>
                            <span class="field-name">】</span></div>
                            <div class="item-calcul">
                                <el-select v-model="item.calculVal"  value-key="id" placeholder="对Y轴数据进行处理" @change="changeOpreaYdata">
                                    <el-option v-for="item in opreaYdata" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                            <div class="item-alias">
                                <el-input v-model.trim="item.alias" placeholder="设置字段显示别名(可选)"></el-input>
                            </div>
                        </div>
                     </el-row>
                     <el-row>
                        <div class="bi-type">
                            <div class="bi-tit">
                                BI类型
                            </div>
                            <div class="bi-type-item" v-for="(item, index) in imgList" :key="index">
                               <img :src="item.url" @click="showData(item.type)" :class="{ active: chartType == item.type }" />
                            </div>
                        </div>
                     </el-row>
                </el-form>
            </div>
        </div>
        <div class="bi-content-main">
            <DashBoard :chartType="chartType" :chartData="chartData" :chartSettings="chartSettings" :showSearch="false" />
        </div>
    </div>
</template>

<script>
import DashBoard from '@/components/DashBoard';
import { getApplicationModelTreeList, getBIFormConfigs, getFormDashBoardConfig } from '@/data-model';
export default {
    name: 'BiConfig',
    comments: {
        DashBoard

    },
    props: {
        biConfigData: {
            type: Object,
            default: () => {
                return {
                    modelTit: '',
                    appId: '',
                    formId: '',
                    modelName: '',
                    remarks: '',
                    modelId: ''
                };
            }
        }
    },
    data () {
        return {
            modelData: {
                modelName: '',
                remarks: '',
                formIds: '',
                modelIds: '',
                id: '',
                formId: ''
            },
            imgList: [
                {
                    url: require('../../assets/img/BI/column.png'),
                    type: 1
                },
                {
                    url: require('../../assets/img/BI/cake.png'),
                    type: 2
                },
                {
                    url: require('../../assets/img/BI/columnTransverse.png'),
                    type: 3
                },
                {
                    url: require('../../assets/img/BI/brokenLine.png'),
                    type: 4
                }
            ],
            chartType: 1,
            appModelsOptions: [],
            XData: [],
            YData: [],
            searchData: [],
            opreaYdata: [{ id: 1, name: '原值显示' }, { id: 2, name: '计数统计' }, { id: 3, name: '加和统计' }, { id: 4, name: '平均统计' }],
            cakeData: [],
            selectXdata: '',
            selectYdata: '',
            selectSearchData: [],
            selectOpreaYdata: '',
            selectCakedata: '',
            isCanSelect: true,
            formData: {},
            chartData: {
                columns: ['数字类型字段1', '数字类型字段2'],
                rows: [
                    { 数字类型字段1: 10000, 数字类型字段2: 5000, dataName: '数据名称1' },
                    { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称2' },
                    { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称3' }
                ]
            },
            BIDimension: 0,
            chartSettings: {},
            dashboardSetting: {},
            dashboardData: {},
            modelId: '',
            allChooseXdata: [],
            allChooseYdata: [],
            formId: '',
            initData: 0,
            id: '',
            yIsmultiple: true,
            canChoose: false,
            showDataSource: '0'
        };
    },
    created () {
        if (this.biConfigData.formId) {
            this.modelData.modelName = this.biConfigData.modelName;
            this.modelData.remarks = this.biConfigData.remarks;
            // 修改
            this.canChoose = true;
            this.eachBiData();
        } else {
            // 新增
            this._initPage();
        }
    },
    methods: {
        async _initPage (obj) {
			let param = {
			    currentPage: 1,
			    pageSize: 100,
			    state: 1,
			    modelType: this.BIDimension
			};
			if (this.BIDimension < 2) {
			    param.aopModelType = 1;
			}
            let modelTree = await getApplicationModelTreeList(param);
            this.appModelsOptions = modelTree;
            if (!this.biConfigData.formId) {
                this.showData(1);
            } else {
                this.$refs.treeSelect.initParam(obj.dashBoardDataConfig.dataModelId);
                this.dashboardSetting = obj.chartSettings;
                this.dashboardData = obj.chartData;
                this.initData = 1;
                this.selectXdata = obj.dimensionIds;
                this.selectYdata = obj.metricsIds;
                this.allChooseXdata = obj.allChooseXdata[0];
                this.allChooseYdata = obj.allChooseYdata;
                this.modelId = obj.dashBoardDataConfig.modelId;
                this.selectOpreaYdata = obj.dashBoardDataConfig.showDataWay;
            }
        },
        initFormList () {
            this._initPage();
        },
        initSelectData () {
            this.selectXdata = '';
            this.selectYdata = '';
            this.selectCakedata = '';
        },
        showData (obj) {
            this.chartType = obj;
            this.chartData = {
                columns: ['数字类型字段1', '数字类型字段2'],
                rows: [
                    { 数字类型字段1: 10000, 数字类型字段2: 5000, dataName: '数据名称1' },
                    { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称2' },
                    { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称3' }
                ]
            };
            this.chartSettings = {
                metrics: ['数字类型字段1', '数字类型字段2'],
                dimension: ['dataName']
            };
        },
        dynamicBiData (e, type) {
            if (type === 1) {
                // x轴
                // 更新X轴的数据
                this.chartData.rows[0].dataName = e.name + '1';
                this.chartData.rows[1].dataName = e.name + '2';
                this.chartData.rows[2].dataName = e.name + '3';
            } else if (type === 2) {
                // Y轴
                this.chartSettings.metrics = [];
                for (var i = 0; i < e.length; i++) {
                    var name = e[i].name;
                    this.chartData.columns.push(name);
                    this.chartData.rows[0][name] = this.randomNum(1, 10000);
                    this.chartData.rows[1][name] = this.randomNum(1, 10000);
                    this.chartData.rows[2][name] = this.randomNum(1, 10000);
                    this.chartSettings.metrics.push(name);
                }
            }
        },
        treeSelectChoose (selected) {
            // 选择好数据源后
            if (selected) {
                this.formId = selected.formId;
                this.modelId = selected.id;
                this.initField(selected);
                if (this.initData === 0) {
                    this.initSelectData();
                } else {
                    this.initData = 0;
                }
            } else {
                this.formData = {};
                this.isCanSelect = true;
                this.selectXdata = '';
                this.selectYdata = '';
                this.searchData = '';
                this.showData(1);
            }
        },
        async initField (selected) {
            var param = { formId: selected.formId, BIDimension: this.BIDimension };
            let field = await getBIFormConfigs(param);
            this.isCanSelect = false; // 解锁字段展现列表
            this.XData = field.allList;
            this.YData = field.allList;
            this.searchData = field.allList;
            this.cakeData = field.allList;
            this.formData = selected;
        },
        changeXdata (e) {
            // 拿到X轴的数据,然后更新展示数据,目前X轴就一条数据后期多了再改造
            let list = this.XData.find(i => i.id === e);
            let currentData = { id: e, name: list.name, type: list.type };
            this.allChooseXdata = currentData;
            // this.allChooseXdata.push(currentData);
            this.dynamicBiData(currentData, 1);
        },
        changeYdata (e) {
            this.catchYData = this.allChooseYdata;
            this.allChooseYdata = [];
            if (e instanceof Array) {
                for (var j = 0; j < e.length; j++) {
                    let yobj = this.catchYData.find(y => y.id === e[j]);
                    if (yobj) {
                        this.allChooseYdata.push(yobj);
                    } else {
                        let list = this.YData.find(i => i.id === e[j]);
                        let currentData = { id: e[j], name: list.name, type: list.type, calculVal: '', alias: '' };
                        this.allChooseYdata.push(currentData);
                    }
                }
            } else {
                let list = this.YData.find(i => i.id === e);
                let currentData = { id: list.id, name: list.name, type: list.type, calculVal: '', alias: '' };
                this.allChooseYdata.push(currentData);
            }
            this.dynamicBiData(this.allChooseYdata, 2);
        },
        changeSearchData (e) {
        },
        messageTip (msg, type) {
            this.$message({
                message: msg,
                type: type,
                duration: 3000
            });
        },
        randomNum (m, n) {
            var num = Math.floor(Math.random() * (m - n) + n);
            return num;
        },
        buildParams () {
            // 参数统一在此构造
            let param = {};
            let dashboardSetting = {};
            dashboardSetting.metrics = [];
            dashboardSetting.metricsIds = [];
            dashboardSetting.metricsFieldType = [];
            dashboardSetting.dimension = [];
            dashboardSetting.dimensionIds = [];
            dashboardSetting.dimensionFieldType = [];
            dashboardSetting.calculVal = [];// 计算规则
            dashboardSetting.alias = [];// 别名
            dashboardSetting.dimension.push(this.allChooseXdata.name);
            dashboardSetting.dimensionIds.push(this.allChooseXdata.id);
            dashboardSetting.dimensionFieldType.push(this.allChooseXdata.type);
            let dashboardData = {};
            dashboardData.columns = [this.allChooseXdata.name];
            dashboardData.columnsIds = [this.allChooseXdata.id];
            dashboardData.columnsFieldType = [this.allChooseXdata.type];
            for (var i = 0; i < this.allChooseYdata.length; i++) {
                var name = this.allChooseYdata[i].name;
                var id = this.allChooseYdata[i].id;
                var type = this.allChooseYdata[i].type;
                var calculVal = this.allChooseYdata[i].calculVal;// 计算规则
                if (!calculVal || calculVal === '') {
                    calculVal = 1;
                }
                var alias = this.allChooseYdata[i].alias;// 别名
                if (!alias || alias === '') {
                    alias = name;
                }
                if (this.allChooseXdata.name === alias) {
                    alias = alias + '数量';
                }
                dashboardSetting.metrics.push(name);
                dashboardSetting.metricsIds.push(id);
                dashboardSetting.metricsFieldType.push(type);
                dashboardSetting.calculVal.push(calculVal);
                dashboardSetting.alias.push(alias);
                dashboardData.columns.push(name);
                dashboardData.columnsIds.push(id);
                dashboardData.columnsFieldType.push(type);
            }
            param.dashboardSetting = JSON.stringify(dashboardSetting);
            param.dashboardData = JSON.stringify(dashboardData);
            param.dashboardType = this.BIDimension;
            param.dataFormId = this.formId;
            param.dataModelId = this.modelId;
            param.dashboardShowType = this.chartType;
            param.showDataWay = this.selectOpreaYdata;
            param.showDataSource = this.showDataSource;
            param.id = this.id;
            return param;
        },
        async eachBiData () {
            this.isCanSelect = false;
            let formId = this.biConfigData.formId;
            let obj = await getFormDashBoardConfig(formId);
            this.BIDimension = obj.dashBoardDataConfig.dashboardType;
            this.chartSettings = obj.chartSettings;
            this.chartData = obj.chartData;
            this.id = obj.dashBoardDataConfig.id;
            this.showDataSource = obj.dashBoardDataConfig.showDataSource;
            // 回显BI类型
            this.chartType = obj.dashBoardDataConfig.dashboardShowType;
            this._initPage(obj);
        },
        changeOpreaYdata () {

        },
        async saveData () {
            if (this.modelData.modelName === undefined || this.modelData.modelName.trim() === '') {
                this.messageTip('请输入模型名称', 'warning');
                return;
            }
            let param = {};
            let biData = this.buildParams();
            param.formName = this.modelData.modelName;
            param.modelName = this.modelData.modelName;
            param.appName = this.biConfigData.modelTit;
            param.appId = this.biConfigData.appId;
            param.modelType = 3;
            param.biData = biData;
            param.remarks = this.modelData.remarks;
            param.id = this.biConfigData.formId;
            param.modelId = this.biConfigData.modelId;
            this.$emit('sendBiData', param);
        }
    }
};
</script>

<style lang="less" scoped="scoped">
.bi-content {
    // border: 1px solid #d6d4d7;
    height: 99%;
    width: 96%;
    top: 0vh;
    overflow: auto;
    position: absolute;
    .bi-content-top{
        .opera-tit-btn{
            display: flex;
            height:6vh;
            line-height: 6vh;
            .tit{
                flex: 1;
                font-size: 1.25rem;
                font-weight: 400;
                text-align: left;
            }
            .btn{
                flex: 1;
                text-align: right;
            }
        }
        .form-data{
            .zb-item{
                display: flex;
                width: 480px;
                height: 40px;
                line-height: 40px;
                margin-left: 20px;
                float: left;
                border: 2px dashed #bbb5b5;
                margin-bottom: 6px;
                .item-field{
                   width:90px;
                   display: flex;
                   .field-name{
                       display: inline-block;
                       text-overflow: ellipsis;
                       white-space: nowrap;
                       overflow: hidden;
                       cursor: pointer;
                   }
                   .field-name-border{
                       display: inline-block;
                   }
                }
                .item-calcul{
                   width: 190px;
                }
                .item-alias{
                   width: 190px;
                }
            }
            .bi-type{
                display: flex;
                padding-left: 32px;
               .bi-type-item {
                   width: 58px;
                   height: 60px;
                   line-height: 60px;
                   float: left;
                   text-align: center;
                   img {
                       width: 30px;
                       height: 30px;
                       cursor: pointer;
                       margin-top: 10px;
                       padding: 5px;
                   }
                   img:hover {
                       width: 40px;
                       height: 40px;
                   }
                   .active {
                       border: 2px solid #009ed0;
                   }
               }
               .bi-tit{
                   width: 60px;
                   height: 60px;
                   line-height: 60px;
               }
               .bi-datasource-tit{
                   height: 60px;
                   line-height: 60px;
                   margin-left:20px;
               }
               .bi-datasource-data{
                   height: 60px;
                   line-height: 60px;
                   margin-left:20px;
               }
            }
        }
    }
    .bi-content-main{
        margin-top: 1vh;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/ConfigDashBoard.vue